<template>
  <header :class="{ scrolled: isScrolled }">
    <div class="header-wrapper">
      <div class="container">
        <nav>
          <div class="logo" @click="scrollToTop">
            <img src="@/assets/logo.png" alt="KiloSeek Logo" class="logo-img">
            <span class="logo-text">千寻搜图</span>
          </div>
          <ul class="nav-links">
<!--            <li><a href="#features" @click.prevent="scrollToSection('features')">功能介绍</a></li>-->
            <li><a href="#pricing" @click.prevent="scrollToSection('pricing')">价格</a></li>
            <li><a href="#tutorial" @click.prevent="scrollToSection('tutorial')">教程</a></li>
            <li><a href="#download" @click.prevent="scrollToSection('download')">下载</a></li>
            <li><a href="https://ocnsl6zz8mao.feishu.cn/wiki/Z1QpweVSdiNQjbkDWMjcQDxWntf?from=from_copylink" target="_blank" >使用说明</a></li>
            <li><a href="#contact" @click.prevent="scrollToSection('contact')">联系我们</a></li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      isScrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 60
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
header {
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: all 0.35s ease;
}

header.scrolled {
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.12);
}

.header-wrapper {
  width: 100%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-img {
  height: 36px;
  width: auto;
  margin-right: 10px;
}

.logo-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--primary);
  letter-spacing: 0.3px;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 8px;
}

.nav-links li {
  margin-left: 0;
}

.nav-links a {
  text-decoration: none;
  color: #4a5568;
  font-weight: 500;
  font-size: 15px;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.25s ease;
  display: block;
}

.nav-links a:hover {
  color: var(--primary);
  background-color: rgba(78, 140, 255, 0.08);
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
  nav {
    height: 60px;
  }
  .logo-text {
    font-size: 15px;
  }
  .nav-links a {
    font-size: 13px;
    padding: 6px 10px;
  }
}
</style>
